/* Olaben: auto-open the cart drawer after any add-to-cart, including the
   collection-card quick add. Subscribes to Dawn's cartUpdate pub/sub event and
   opens the drawer if it isn't already open. Safe/idempotent: if the theme's own
   renderContents() already opened the drawer, this is a no-op. Classic script
   (not a module) so Shopify's asset pipeline won't rewrite it. */
(function () {
  function openDrawer() {
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.open === 'function' && !drawer.classList.contains('active')) {
      drawer.open();
    }
  }

  function bind() {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined' || !PUB_SUB_EVENTS.cartUpdate) {
      return false;
    }
    subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
      // Let the theme's renderContents() refresh the drawer first, then ensure it's open.
      setTimeout(openDrawer, 80);
    });
    return true;
  }

  if (!bind()) {
    document.addEventListener('DOMContentLoaded', function () {
      if (!bind()) setTimeout(bind, 500);
    });
  }
})();
